export default "__VITE_ASSET__BRymMXqX__"